export default "__VITE_ASSET__KUVVvA0r__"